import { IWorkResourceEmployee, IWorkResourceEmployeeReport } from "../common/data/dtos/work-resource-employee";
import { IWorkResourceEmployeeSign } from "../common/data/dtos/work-resource-employee-sign";
import WorkResourceEnum from "../common/data/enums/enumWorkResouce";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/WorkResourceEmployee';

interface WorkResourceEmployeeResponse {
    success: boolean;
    workResourceEmployee?: IWorkResourceEmployee;
    workResourceEmployees?: IWorkResourceEmployee[];
    error?: string;
}

interface WorkResourceEmployeeReportResponse {
    success: boolean;
    workResourceEmployeeReport?: IWorkResourceEmployeeReport;
    error?: string;
}

type CreateIWorkResourceEmployeeType = Omit<IWorkResourceEmployee, 'id'> | Partial<IWorkResourceEmployee>;

const createWorkResourceEmployee = async (workResourceEmployee: CreateIWorkResourceEmployeeType): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}`, workResourceEmployee);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const createManyWorkResourceEmployee = async (workResourceEmployee: CreateIWorkResourceEmployeeType[]): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}`, workResourceEmployee);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteWorkResourceEmployee = async (id: string): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getWorkResourceEmployees = async (): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResourceEmployees: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOneWorkResourceEmployee = async (id: string): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResourceEmployee: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateWorkResourceEmployee = async (workResourceEmployee: IWorkResourceEmployee): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}/${workResourceEmployee.id}`, workResourceEmployee);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getWorkResourceEmployeeByEmployee = async (id: string): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}/GetByEmployee?id=${id}`);
        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResourceEmployees: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const signWorkResourceEmployee = async (workResourceEmployeeSign: IWorkResourceEmployeeSign): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}/sign`, workResourceEmployeeSign);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const changeWorkResourceEmployee = async (workResourceEmployee: CreateIWorkResourceEmployeeType): Promise<WorkResourceEmployeeResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkResourceEmployee>(`${BASE_PATH}/change`, workResourceEmployee);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getWorkResourceEmployeeReport = async (employeeId: string, type: WorkResourceEnum): Promise<WorkResourceEmployeeReportResponse> => {
        try {
        const response = await GET_TYPED_ASYNC<IWorkResourceEmployeeReport>(`${BASE_PATH}/GetWorkResouceEmployeeReport?employeeId=${employeeId}&type=${type}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResourceEmployeeReport: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};


export default {
    createWorkResourceEmployee,
    createManyWorkResourceEmployee,
    deleteWorkResourceEmployee,
    getWorkResourceEmployees,
    getOneWorkResourceEmployee,
    updateWorkResourceEmployee,
    getWorkResourceEmployeeByEmployee,
    signWorkResourceEmployee,
    changeWorkResourceEmployee,
    getWorkResourceEmployeeReport
};